import { UseIsMobile } from 'common/hooks/UseIsMobile'
import DesktopChangePassword from './Desktop'
import MobileChangePassword from './Mobile'

export default function ForgetChangePassword() {
  const mobile = UseIsMobile()

  return (
    <div>
      {
        !mobile ?
          <div className='hidden md:block'>
            <DesktopChangePassword />
          </div>
          :
          <div className='block md:hidden'>
            <MobileChangePassword />
          </div>
      }
    </div>
  )
}